import { fbt } from 'fbtee'
import { Link, useLocation } from 'react-router-dom'
import { BottomBanner } from './BottomBanner'
import { useAuth } from '@/hooks/useAuth'
import { useGuestPickCount } from '@/hooks/useGuestSetPicks'
import { GUEST_PICKS_FOOTER_THRESHOLD } from '@/lib/guestSetPicks'
import { logInButtonLabel } from '@/lib/commonStrings'
import { track } from '@/lib/analytics'

const HIDDEN_ON = new Set(['/login', '/dev-signin'])

// A status line, not a nag: no dismiss, so a guest's device-only picks can't be
// silently forgotten.
export function GuestPicksFooter() {
  const count = useGuestPickCount()
  const location = useLocation()
  return (
    <BottomBanner className="md:hidden" testId="guest-picks-footer">
      <div className="flex-1 min-w-0">
        <div className="text-[13px] font-semibold leading-tight truncate">
          <fbt desc="Status footer telling a signed-out visitor how many set picks are saved on this device">
            <fbt:plural count={count} many="picks saved" showCount="yes">
              pick saved
            </fbt:plural>
          </fbt>
        </div>
        <div className="text-[11px] text-muted-foreground leading-tight truncate">
          {fbt('Create an account to share with your crew', 'Subtitle in the guest picks footer explaining why to sign up')}
        </div>
      </div>
      <Link
        to="/login"
        state={{ from: location }}
        onClick={() => track('guest_picks_footer_tapped', { set_count: count })}
        className="flex-none rounded-full bg-primary px-3.5 py-1 text-xs font-bold uppercase tracking-wide text-primary-foreground hover:bg-primary/90"
      >
        {logInButtonLabel()}
      </Link>
    </BottomBanner>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export function useShowGuestPicksFooter(): boolean {
  const { signedInUid, loading } = useAuth()
  const count = useGuestPickCount()
  const { pathname } = useLocation()
  return !loading && !signedInUid && count >= GUEST_PICKS_FOOTER_THRESHOLD && !HIDDEN_ON.has(pathname)
}
